import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Home from "@/pages/public/Home";
import JobDetail from "@/pages/public/JobDetail";
import Contact from "@/pages/public/Contact";
import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import ResetPassword from "@/pages/auth/ResetPassword";
import ApplyRouter from "@/pages/candidate/ApplyRouter";
import CandidateDashboard from "@/pages/candidate/CandidateDashboard";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import Candidates from "@/pages/admin/Candidates";
import CandidateDetail from "@/pages/admin/CandidateDetail";
import Analysis from "@/pages/admin/Analysis";
import Compare from "@/pages/admin/Compare";
import Jobs from "@/pages/admin/Jobs";
import EmailTemplates from "@/pages/admin/EmailTemplates";
import Settings from "@/pages/admin/Settings";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/careers" element={<Home />} />
            <Route path="/jobs/:slug" element={<JobDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin/login" element={<Login admin />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route path="/apply/:slug" element={<ProtectedRoute role="candidate"><ApplyRouter /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute role="candidate"><CandidateDashboard /></ProtectedRoute>} />

            <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/candidates" element={<ProtectedRoute role="admin"><Candidates /></ProtectedRoute>} />
            <Route path="/admin/candidates/:id" element={<ProtectedRoute role="admin"><CandidateDetail /></ProtectedRoute>} />
            <Route path="/admin/applications" element={<ProtectedRoute role="admin"><Candidates /></ProtectedRoute>} />
            <Route path="/admin/analysis" element={<ProtectedRoute role="admin"><Analysis /></ProtectedRoute>} />
            <Route path="/admin/compare" element={<ProtectedRoute role="admin"><Compare /></ProtectedRoute>} />
            <Route path="/admin/jobs" element={<ProtectedRoute role="admin"><Jobs /></ProtectedRoute>} />
            <Route path="/admin/emails" element={<ProtectedRoute role="admin"><EmailTemplates /></ProtectedRoute>} />
            <Route path="/admin/settings" element={<ProtectedRoute role="admin"><Settings /></ProtectedRoute>} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
